/* eslint-disable prettier/prettier */
/*
  Project: Yanmar
  Author: Xfive
 */

import 'matchheight';
import './modules/scrollbar-width';
import './modules/dealer-locator';
import './modules/downloads';
import './modules/facets';
import './modules/ie-detector';
import './modules/logos-slider';
import './modules/navigation';
import './modules/carousel-slider';
import './modules/scroll-to';
import './modules/slider';
import './modules/sticky-search';
import './modules/tabs';
import './modules/toggle';
import './modules/statement';
import './modules/popup-content';
import './modules/popup-url-trigger';
import './modules/faq';
import './modules/footer';
import './modules/schema-faq';
import './modules/gravity-forms-ajax';
import './modules/configurator';
import './modules/teamtailor-apply';


// See fit modal form adjust thank you message
document.addEventListener("d365mkt-afterformsubmit", () => {
  setTimeout(() => {
    const thankyou = document.querySelector('.onFormSubmittedFeedback');

    if (thankyou) {
      thankyou.style.height = 'auto';
    }
  }, 100);
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/app.js